/* eslint-disable */
"use client";
import * as Icon from "@/components/tools/icons";
import { copyToClipboard } from "@/utils";
import { useEffect, useState } from "react";
import { Tooltip } from "antd";
import Image from "next/image";
import { TooltipPlacement } from "antd/es/tooltip";

const CopyText = ({
  className,
  value,
  actualValue,
  onClick,
  copyShow,
  toolTipPlacement,
}: {
  value: string | number | undefined;
  actualValue?: string | number | undefined | null;
  onClick?: () => void;
  copyShow?: boolean;
  toolTipPlacement?: TooltipPlacement;
  className?: string;
}) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (copied) {
      const timer = setTimeout(() => {
        setCopied(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [copied]);

  return value ? (
    <>
      {actualValue !== "0" && actualValue ? (
        <Tooltip
          title={actualValue}
          placement={toolTipPlacement}
          className={" text-white rounded tooltipContent"}
        >
          <span
            onClick={() => onClick?.()}
            className={className || "cursor-pointer"}
          >
            {value}
          </span>
        </Tooltip>
      ) : (
        <span
          onClick={() => onClick?.()}
          className={className || "cursor-pointer"}
        >
          {value}
        </span>
      )}
      {value && value !== "-" && !copyShow && (
        <span
          onClick={() => {
            copyToClipboard(String(actualValue || value));
            setCopied(true);
          }}
          className="cursorPointer"
        >
          {!copied ? (
            <Icon.Copy className="inline-block" />
          ) : (
            <Image
              className="inline-block copyIcon"
              src="/icons/tick.svg"
              width={24}
              height={24}
              alt="Copied"
            />
          )}
        </span>
      )}
    </>
  ) : (
    "-"
  );
};

export default CopyText;
